import { render } from "./createOrder.vue?vue&type=template&id=5caf72de&scoped=true"
import script from "./createOrder.vue?vue&type=script&lang=js"
export * from "./createOrder.vue?vue&type=script&lang=js"

import "./createOrder.vue?vue&type=style&index=0&id=5caf72de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5caf72de"]])

export default __exports__